module.exports = __webpack_public_path__ + "img/emptyjdillust.8d734448.svg";